export default angular.module("mars.vet.dnareports.controllers.thescience",[]).controller('TheScienceController', function($rootScope, $scope, $routeParams, $window, EntryService, EntryIDService, NavigationService) {
  'ngInject';
    EntryService.getEntry(EntryIDService.getEntryID('The Science')).then(function(response) {
        var fields = response.fields;
        $rootScope.pageTitle = fields.title;
        $scope.description = fields.description;
        $scope.descriptionArray = [];

        angular.forEach($scope.description.split("\n"), function(value, key) {
            if (value != '') {
                $scope.descriptionArray.push(value);
            }
        });
        NavigationService.setNavigationUrls();
        $window.ga('send', 'pageview', {
            'page': $rootScope.pageTitle
        });
    });
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/thescience.controller.js